import React from "react";
import DisplayCardList from "../../componenets/DisplayCardList";
import { praticeData } from "../../data";

const PracticeHome = () => {
  return <DisplayCardList data={praticeData} />;
};

export default PracticeHome;
